export const ACTIVE_CHATS_TITLE = 'Atendimentos em andamento';
export const DEALS_CLOSED_TITLE = 'Acordos fechados';
export const STARTED_MESSAGES_TITLE = 'Conversas iniciadas';
export const UNREAD_MESSAGES_TITLE = 'Mensagens não lidas'; 
export const CALLS_MADE_TITLE = 'Chamadas realizadas';
export const CALLS_WITH_ANSWER_TITLE = 'Chamadas que resultaram em resposta';